// @givmo/board — the Minute book's way-finding words (CBG-UX8-BOOK; design stop design-268's §2 and
// §9, frames b1 and b2).
//
// ══ WHICH WORDS ARE APPROVED ════════════════════════════════════════════════════════════════════
//
// All of them. Jonathan approved the screens for building with every new word a draft (D-CBG-35,
// 2026-10-22 23:09 PDT, "looks good"), and the words, every row as recommended, in the wayfinding copy
// round (2026-10-24 11:11 PDT). Each line names the frame that draws it, or "not drawn" for a state no
// frame shows. The first two are the plan's own words (CBG-UX8 items 2 and 3). The page's old one line
// ("These records are yours — download a complete copy anytime.", approved in CBG-UX1) moved behind
// "How this works" and stays in the page's own fine print.
//
// ⚠ What the book holds and where a record starts, never what a board ought to record: no line
// counts what is missing, says a meeting needs minutes, or names a deadline (plan §3.2, §3.4).

export const minuteBookWords = {
  // ── The header (frames b1, b2) ──────────────────────────────────────────────────────────────────

  // Drawn b1 and b2: under the title, what the book holds (3.1).
  holds:
    'Your board’s records: approved minutes, written consents and resolutions, including records from before you used Givmo.',
  // Drawn b1 and b2: the way to make a record, split around its two links.
  writingMinutes: 'Writing minutes?',
  // Drawn b1 and b2: the first link, to Meetings.
  openTheMeeting: 'Open the meeting in Meetings',
  // Drawn b1 and b2.
  decidingWithout: 'Deciding without a meeting?',
  // Drawn b1 and b2: the second link, to Written consents.
  startAConsent: 'Start a written consent',

  // ── Minutes still being drafted (frame b1) ──────────────────────────────────────────────────────

  // Drawn b1: the group's label.
  inProgress: 'In progress',
  // Drawn b1: each row's way to its meeting's Minutes tab.
  openTheMinutes: 'Open the minutes',
  /**
   * Drawn b1 ("Draft · last changed Oct 20, 2027"): the minutes' own state word, as the book says it
   * ("Draft", or "Out for signatures"; `recordStandingLabel`), then the day.
   *
   * Left as drafted (CBG-UX-COPY1's row 7.3, by Jonathan's choice): minutes out for a written consent
   * read "Draft", which is true — they stay a draft until the board approves them, and the meeting's
   * Minutes tab says where they stand. A word like "Out for approval" needs a fact the book's read
   * doesn't serve: that the minutes are out for a consent.
   */
  stateChanged: (state: string, day: string) => `${state} · last changed ${day}`,
  // Not drawn: under the list, when it is all the book holds.
  nothingApprovedYet: 'Nothing approved yet.',

  // ── The empty book (frame b2) ───────────────────────────────────────────────────────────────────

  // Drawn b2: the third way a record starts, for someone who can import.
  olderRecords: 'Records from before Givmo?',
  // Drawn b2: its link (the page's own action's words).
  importThem: 'Import older records',
} as const;
